import { useNavigate } from 'react-router-dom';
import { Box, Drawer, List, ListItem, ListItemButton, Typography } from '@mui/material';
import { useUserSlice } from '#/store/slices/user/userSlice';
import { routeInfo, type RouteInfo } from './routeInfo';

const sidebarLinks: ({ label: string; route: string } & RouteInfo)[] = [
  { label: 'Dashboard', route: '/', ...routeInfo[''] },
  { label: 'Educators', route: '/instructors', ...routeInfo['instructors'] },
  { label: 'Students', route: '/students', ...routeInfo['students'] },
  { label: 'Administrators and Staff', route: '/administrators', ...routeInfo['administrators'] },
  { label: 'Classes', route: '/classes', ...routeInfo['classes'] },
  // { label: 'Attendance', route: '/attendance', userTypes: ['administrator', 'instructor'] },
  { label: 'Reports', route: '/reports', ...routeInfo['reports'] },
  { label: 'Assessments', route: '/assessments', ...routeInfo['assessments'] },
  // { label: 'Settings', route: '/settings', ...routeInfo['settings'] }
];

interface SidebarProps {
  drawerOpen: boolean;
}

function Sidebar({ drawerOpen }: SidebarProps) {
  const { pathname } = window.location;
  const navigate = useNavigate();
  const { activeRole } = useUserSlice();

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={drawerOpen}
      sx={{
        width: 240,
        '& .MuiDrawer-paper': {
          backgroundColor: (t) => t.palette.primary.main,
          color: 'white',
          width: 240,
          boxSizing: 'border-box',
          top: 60,
          height: 'calc(100vh - 60px)',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box className="drawer-content" sx={{ flexGrow: 1 }}>
        <List>
          {sidebarLinks.map((s, i) => {
            if (!s.userTypes.includes(activeRole)) return null;

            return (
              <ListItem disablePadding key={i}>
                <ListItemButton
                  onClick={() => handleNavigation(s.route)}
                  selected={s.route === '/' ? pathname === '/' : pathname.includes(s.route)}
                  sx={{
                    display: 'flex', alignItems: 'center',
                    '&.Mui-selected': {
                      backgroundColor: 'primary.light',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: 'primary.light',
                      },
                    },
                  }}
                >
                  <s.icon size={24} />
                  <Typography fontSize="inherit" ml={2}>{s.label}</Typography>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </Drawer>
  );
}

export default Sidebar;
